import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { selectIsSharingZoomEnabled } from '../../../../../shared/features/flags/selectors';

/**
 * Предотвращает нативный pinch-to-zoom.
 *
 * Хендлит два вида приближения:
 * 1. Приближение колесиком + ctrl (Хром так распознает pinch на тачпаде)
 * 2. События жестов Safari (gesturestart/gesturechange/gestureend)
 */
export function usePreventNativeZoom(): void {
    const isSharingZoomEnabled = useSelector(selectIsSharingZoomEnabled);

    useEffect(() => {
        if (!isSharingZoomEnabled) {
            return;
        }

        const handleWheel = (event: WheelEvent) => {
            if (event.ctrlKey) {
                event.preventDefault();
            }
        };

        const handleGesture = (event: Event) => {
            event.preventDefault();
        };

        document.addEventListener('wheel', handleWheel, { passive: false });
        document.addEventListener('gesturestart', handleGesture);
        document.addEventListener('gesturechange', handleGesture);
        document.addEventListener('gestureend', handleGesture);

        return () => {
            document.removeEventListener('wheel', handleWheel);
            document.removeEventListener('gesturestart', handleGesture);
            document.removeEventListener('gesturechange', handleGesture);
            document.removeEventListener('gestureend', handleGesture);
        };
    }, [isSharingZoomEnabled]);
}
